import type { RouterOptions } from "@nuxt/schema";

// noinspection JSUnusedGlobalSymbols
export default <RouterOptions>{
	scrollBehavior(to, from, savedPosition) {
		if (to.path.includes("/product/")) {
			return false;
		}
		if (savedPosition) {
			return savedPosition;
		} else {
			return {
				top: 0,
				behavior: "smooth",
			};
		}
	},
};
